import {Component, OnInit} from '@angular/core';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {WorkingObjectTechnicalDevicePagesService} from '../../services/working-object-technical-device-pages.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-technical-device-list',
    templateUrl: 'technical-device-list.component.html',
    styleUrls: ['technical-device-list.component.scss'],
})
export class TechnicalDeviceListComponent extends ListItemsComponent<WorkingObjectTechnicalDevicePagesService> implements OnInit {

    permissions = UserNamespace.Permission;

    newUrl: string;

    constructor(
        service: WorkingObjectTechnicalDevicePagesService,
        private route: ActivatedRoute,
    ) {
        super(service);
    }

    ngOnInit(): void {
        super.ngOnInit();
        const objectId = +this.route.parent.snapshot.params.id;

        this.newUrl = RoutesStorage.TechnicalDevice.new(objectId);
    }
}
